const tokenPrime = 'E7U1xtL7CO6zTSS82g3AaArcKld'
//HOMOLOG : dRc9HOHgfpJVBEvm5TpwJSqpJ PROD : E7U1xtL7CO6zTSS82g3AaArcKld
export default tokenPrime